(function (argument) {
	'use strict';

	angular.module("changdobels")
		.directive("cdThemeSrc", cdThemeSrc);

	cdThemeSrc.$inject = ['TEMPLATE_URL'];

	function cdThemeSrc(TEMPLATE_URL) {
		return {
			link: function (scope, element, attributes) {
				element.attr('src', TEMPLATE_URL + attributes.cdThemeSrc);
			}
		};
	}
})();